const DEFAULT_MAX_LENGTH = 500

const EMAIL_PATTERN = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g
const NNI_LIKE_PATTERN = /\b[a-zA-Z0-9]{6,8}\b/g
const PHONE_PATTERN =
  /(?:\+33|0)\s*[1-9](?:[\s.-]*\d{2}){4}|\b0[1-9]\d{8}\b/g
const QUERY_STRING_PATTERN = /\?[^?\s]*/g

/**
 * Nettoie un texte potentiellement porteur de PII avant envoi stats.
 */
export function scrubPotentialPii(text: unknown, maxLength = DEFAULT_MAX_LENGTH): string {
  if (text === null || text === undefined) {
    return ''
  }
  let value = String(text)
  value = value.replace(QUERY_STRING_PATTERN, '')
  value = value.replace(EMAIL_PATTERN, '[REDACTED]')
  value = value.replace(PHONE_PATTERN, '[REDACTED]')
  value = value.replace(NNI_LIKE_PATTERN, '[REDACTED]')
  const safeMax =
    Number.isFinite(maxLength) && maxLength > 0 ? Math.floor(maxLength) : DEFAULT_MAX_LENGTH
  if (value.length > safeMax) {
    return value.slice(0, safeMax)
  }
  return value
}
